import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function SectionFaq() {
  const [openId, setOpenId] = useState<string | null>('faq-1');

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 mx-auto max-w-3xl">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-sm font-medium text-primary-600 mb-2">答疑解惑</p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">常见问题</h2>
          <p className="text-foreground-500 text-sm mt-3">关于爱看影院的常见疑问，这里都有答案</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-200/50 transition-colors duration-200"
                  onClick={() => setOpenId(isOpen ? null : item.id)}
                >
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">{item.question}</h3>
                  <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                    isOpen ? 'bg-primary-100 text-primary-600 rotate-45' : 'bg-background-200 text-foreground-500'
                  }`}>
                    <i className="ri-add-line text-sm"></i>
                  </div>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}